import 'pixi-sound';
import { Sprite } from 'pixi.js';
import BoardUtils from '../../../Game/BoardUtils';
import { ITileType } from '../../../Tiles/TileSet';
import { Collection, Suits } from '../../../Tiles/TileSet';
import { getSpriteId } from '../../../Utils/CollectableUtils';
import { BoardSprite } from './BoardSprite';

export class TileSprite extends BoardSprite {
    public static TILE_SELECT_TIME: number = 200;
    public static TILE_MATCH_TIME: number = 400;

    private tileType: PIXI.Sprite;

    constructor(tileType: ITileType, tileSize: [number, number], collection: Collection) {
        const bgId = tileType.suit === Suits.BOOSTER ? 'tile-booster' : 'tile-bg';
        super(getSpriteId(bgId, collection), tileSize, collection);
        const tileIcon = (this.tileType = new Sprite(
            PIXI.utils.TextureCache[getSpriteId(tileType.suit + '-' + tileType.value, collection)]
        ));
        const { width, height } = this;

        const iconShiftX = 6 / 136;
        const iconShiftY = 6 / 169;
        tileIcon.x = -(width * iconShiftX);
        tileIcon.y = -(height * iconShiftY);
        tileIcon.anchor.set(0.5, 0.5);

        this.addChild(tileIcon);
        this.isAvailable = true;
        this.isMatched = false;
        this.spriteId = BoardUtils.formatId(tileType);
    }

    public setTypeVisible(visible: boolean): void {
        this.tileType.alpha = visible ? 1 : 0;
    }
}
